import { blackColors } from 'assets/jss/material-dashboard-pro-react';

const infoStyles = (theme) => ({
	infoRowContainer: {
		display: 'flex',
		marginTop: 4,
		'&:first-of-type': {
			marginTop: 0,
		},
		'& > p:nth-child(2), & > div:nth-child(2)': {
			textAlign: 'right',
		},
		'& > p, & > div': {
			width: '100%',
			marginBottom: 3,
		},
	},
	border: {
		borderBottom: `1px solid ${blackColors[6]}`,
	},
	ebillSubheader: {
		display: 'inline',
		[theme.breakpoints.down('xs')]: {
			display: 'block',
			marginLeft: 50,
		},
	},
	infoCard: {
		marginBottom: 10,
		position: 'relative',
		'& > div': {
			paddingBottom: '36px',
		},
		height: 'calc(100% - 24px)',
	},
	withButtons: {
		'& > div': {
			paddingBottom: '83px',
		},
	},
	infoCardButtonsContainer: {
		textAlign: 'right',
		borderTop: `1px solid ${blackColors[6]}`,
		position: 'absolute',
		bottom: 0,
		width: 'calc(100% - 40px)',
	},
	topButton: {
		position: 'absolute',
		top: '1px',
		right: '20px',
	},
	title: {
		marginBottom: '12px',
		maxWidth: '100%',
	},
	withBody: {
		'& > div': {
			paddingBottom: '56px',
		},
	},
	numbersAffected: {
		flexWrap: 'wrap',
	},
});

export default infoStyles;
